import React, { useEffect, useState } from 'react';
import { Button, InputField } from '@synergy-marine-group/synergy-ui';
import { gotopervousPage, gotonextPage, updatepage, updateSize } from '../../features/pagecount/pageSlice';

const Pagination = ({
  previousPage,
  canPreviousPage,
  pageOptions,
  gotoPage,
  setPageSize,
  totalPages,
  nextPage,
  pageIndex,
  canNextPage,
  currentPage,
  pageSize,
  rowCount,
  dispatch
}) => {
  const [pageValue, setpageValue] = useState(currentPage || pageIndex + 1);
  useEffect(() => {
    setpageValue(pageIndex + 1);
  }, [pageIndex]);
  useEffect(() => {
    setpageValue(currentPage);
  }, [currentPage]);
  return (
    <div className="pagination mt-6 ">
      <Button
        className="bg-primary-500 text-white-DEFAULT"
        variant="filled"
        rounded
        onClick={() => {
          setpageValue(pageValue - 1);
          previousPage();
          if (currentPage) {
            dispatch(gotopervousPage());
          }
        }}
        disabled={!canPreviousPage}
        size="medium"
      >
        <div className="text-white-DEFAULT">Previous</div>
      </Button>

      <span className="flex items-center">Page</span>

      <InputField
        className=" w-22 pagination-page-counts"
        id="number"
        variant="number"
        rounded
        defaultValue={1}
        min={1}
        max={totalPages || pageOptions?.length}
        onChange={(e) => {
          if (e.target.value <= totalPages || e.target.value <= pageOptions?.length) {
            // only set positive values
            if (e.target.value >= 0) {
              setpageValue(e.target.value);
            }
          }
        }}
        onKeyPress={(e) => {
          if (e.key === 'Enter') {
            const pag = e.target.value > 0 ? Number(e.target.value) : 1;
            setpageValue(pag);
            if (pageOptions) {
              gotoPage(pag - 1);
            } else {
              gotoPage(pag);
              if (pag >= 0) {
                dispatch(updatepage(pag));
              }
            }
          }
        }}
        onClick={(e) => {
          const pag = e.target.value > 0 ? Number(e.target.value) : 1;
          setpageValue(pag);
          if (pageOptions) {
            gotoPage(pag - 1);
          } else {
            gotoPage(pag);
            if (pag >= 0) {
              dispatch(updatepage(pag));
            }
          }
        }}
        size="small"
        value={pageValue}
      />

      <span className="flex items-center">
of
{' '}
{totalPages || pageOptions?.length || 1}
      </span>

      <select
        className="dropdown-pagination  w-full"
        value={pageSize}
        onChange={(e) => {
          setPageSize(Number(e.target.value));
          setpageValue(1);
          if (pageOptions) {
            gotoPage(0);
          }
          dispatch(updateSize(Number(e.target.value)));
          dispatch(updatepage(1));
        }}
      >
        {rowCount?.map((pageSize1) => (
          <option key={pageSize1} value={pageSize1}>
            {pageSize1}
{' '}
rows
          </option>
        ))}
      </select>

      <Button
        className="bg-primary-500"
        onClick={() => {
          setpageValue(pageValue + 1);
          nextPage();
          if (currentPage) {
            dispatch(gotonextPage());
          }
        }}
        disabled={!canNextPage}
        rounded
        size="medium"
        variant="filled"
      >
        <div className="text-white-DEFAULT">Next</div>
      </Button>
    </div>
  );
};

export default Pagination;
